<app-sending *ngIf="sending"></app-sending>
<p class="c-texts--attention h-margin--b16">＊は入力必須項目です</p>
<app-input-table [formItems]="formItems" [formValue]="formValue"></app-input-table>
<app-under-btn-disp [actionButtons]="actionButtonsDisp"></app-under-btn-disp>
